var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraySixInsertedTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 294.8 113.6",
    style: {
      enableBackground: "new 0 0 294.8 113.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#207D8C;}\n\t.st1{fill:#323341;}\n\t.st2{fill:none;stroke:#ED2024;stroke-width:0.99;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,10c-4.4,0-8,3.6-8,8v95.6h282.9V32.8c0-7.2-3.1-9.8-10.5-9.9c-7.4-0.1-1.6,0-12.2,0 c-9.6,0-10.5-6.6-10.5-6.6s-1-6.3-8.8-6.3C245.2,10,19.9,10,19.9,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.6,0c-4.4,0-8,3.6-8,8v95.6h282.9V22.8c0-7.2-3.1-9.9-10.5-9.9c-7.4-0.1-1.6,0-12.1,0 c-9.6,0-10.5-6.6-10.5-6.6s-1-6.3-8.8-6.3S9.6,0,9.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8,54.1c0.2,13.6-10.6,24.7-24.2,24.9c-0.2,0-0.3,0-0.5,0L54.5,78.8c-13.8-0.1-25.1-11.1-25.4-24.9 C28.9,40.3,39.7,29.2,53.3,29c0.2,0,0.3,0,0.5,0l174.7,0.2C242.2,29.2,253.5,40.3,253.8,54.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0,12.9 0.4,12.9 0.4,12.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,40.8v-4h-32.1c0.9,1.3,1.7,2.6,2.4,4H284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6,36.8v4h25.9c0.6-1.4,1.4-2.7,2.2-4H1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6,44.8v4h23.7c0.2-1.4,0.4-2.7,0.8-4H1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,48.8v-4h-28c0.4,1.3,0.7,2.6,0.9,4H284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1,52.6H1.6v4h23.6l0-1.3L25.1,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,55.6v1h26.7v-4h-26.8v0.1L257.8,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6,60.4v4h25.2c-0.5-1.3-0.9-2.6-1.1-4L1.6,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,64.4v-4h-27.1c-0.2,1.4-0.6,2.7-1,4H284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,71.7v-4h-29.4c-0.7,1.4-1.5,2.7-2.4,4H284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6,67.7v4h29.2c-1-1.3-1.8-2.6-2.5-4H1.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraySixInsertedTop);
export default __webpack_public_path__ + "static/media/gray-six-inserted-top.cc74d41e5edf07678efaea5e84490f5b.svg";
export { ForwardRef as ReactComponent };